import sanitizeHtml from "sanitize-html";

const ALLOWED_HTML_OPTIONS = {
    allowedTags: [
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'a', 'ul', 'ol', 'nl', 'li', 'b', 'i',
        'strong', 'em', 'strike', 'code', 'hr', 'br', 'div', 'thead', 'caption', 'tbody', 'tr', 'th', 'td',
        'pre', 'img', 'button', 'address', 'center', 'col', 'colgroup', 'embed', 'fieldset', 'form',
        'input', 'ins', 'label', 'object', 'param', 'span', 'style', 'sup', 'table', 'iframe'
    ],
    allowedAttributes: {
        ...sanitizeHtml.defaults.allowedAttributes, ...{
            a: ['class', 'data-flickr-embed', 'href', 'id', 'hrefarr', 'name', 'target', 'title', 'data-footer', 'style', 'rel', 'style', 'data-header', 'onclick', 'target'],
            address: ['style'],
            blockquote: ['style'],
            br: ['style'],
            center: ['style'],
            col: ['width', 'style'],
            colgroup: ['style'],
            div: ['class', 'style', 'aria-hidden"', 'id'],
            em: ['style'],
            embed: ['class', 'style', 'type', 'src', 'width', 'height'],
            fieldset: ['class', 'style', 'name'],
            form: ['class', 'style', 'action', 'method', 'id', 'name', 'target', 'novalidate'],
            h1: ['class', 'style'],
            h2: ['class', 'style'],
            h3: ['class', 'style', 'id'],
            h4: ['class', 'style'],
            h5: ['class', 'style'],
            h6: ['class', 'style'],
            hr: ['size', 'noshade', 'style'],
            img: ['src', 'height', 'alt', 'class', 'style', 'title', 'width'],
            input: ['style', 'type', 'id', 'name', 'value', 'class'],
            ins: ['datetime', 'cite', 'style'],
            label: ['class', 'style', 'for'],
            li: ['class', 'style'],
            object: ['class', 'style', 'width', 'height'],
            ol: ['class', 'style', 'type'],
            p: ['class', 'for', 'id', 'style'],
            param: ['class', 'style', 'name', 'value'],
            span: ['style', 'inline', 'class'],
            strong: ['id', 'style', 'class'],
            style: ['type'],
            sup: ['style'],
            table: ['border', 'class', 'style', 'width', 'height', 'cellpadding', 'cellspacing'],
            tbody: ['style'],
            td: ['align', 'class', 'colspan', 'height', 'rowspan', 'scope', 'style', 'valign', 'width'],
            th: ['colspan', 'width', 'style'],
            tr: ['class', 'align', 'height', 'style', 'width'],
            ul: ['class', 'style', 'type'],
            button: ['style', 'width', 'height', 'class'],
            iframe: ['src', 'width', 'height', 'style', 'title']
        }
    },
    selfClosing: ['img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta', 'style'],
};

export function insertHtml(html: string): { dangerouslySetInnerHTML: any } {

    return {
        dangerouslySetInnerHTML: {
            __html: sanitizeHtml(html, ALLOWED_HTML_OPTIONS)
        }
    };
}

export function html_substr(str: string, count: number, suffix: string = "") {

    const div = document.createElement('div');
    div.innerHTML = str;

    walk(div, track);

    function track(el: any) {
        if (count > 0) {
            const len = el.data.length;
            count -= len;
            if (count <= 0) {
                el.data = el.substringData(0, el.data.length + count) + suffix;
            }
        } else {
            el.data = '';
        }
    }

    return div.innerHTML;
}

function walk(el: any, fn: any) {
    let node = el.firstChild;
    do {
        if (node.nodeType === 3) {
            fn(node);
        } else if (node.nodeType === 1 && node.childNodes && node.childNodes[0]) {
            walk(node, fn);
        }
        node = node.nextSibling;
    } while (node);
}